import React from 'react';

import MomentUtils from '@date-io/moment';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import CalendarIcon from '@material-ui/icons/CalendarToday';
import LeftIcon from '@material-ui/icons/ChevronLeft';
import RightIcon from '@material-ui/icons/ChevronRight';
import {
  DatePickerProps as DateTimePickerProps,
  DateTimePicker,
  MaterialUiPickersDate,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import moment from 'moment';
import { connect, DispatchProp } from 'react-redux';
import { compose, defaultProps, setDisplayName } from 'recompose';

export type IDateTimePickerProps = DateTimePickerProps;

export default compose<
  IDateTimePickerProps & Required<DispatchProp<{ type: string }>>,
  IDateTimePickerProps
>(
  setDisplayName('DateTimePicker'),
  defaultProps({
    InputProps: {
      endAdornment: (
        <InputAdornment position="end">
          <IconButton>
            <CalendarIcon />
          </IconButton>
        </InputAdornment>
      ),
    },
    leftArrowIcon: <LeftIcon />,
    rightArrowIcon: <RightIcon />,
    format: 'L LT',
    showTabs: false,
  }),
  connect<any, any, IDateTimePickerProps, AppState>((state, ownProps) => ({
    ampm: state.localeDateTime.time.useMeridiem,
    value: moment.isMoment(ownProps.value) ? ownProps.value.toDate() : ownProps.value, // don't use moment instance => won't refresh on locale change
  }))
)(({ dispatch, onChange, ...props }) => {
  const [selectedDate, handleDateChange] = React.useState<Date | MaterialUiPickersDate>(new Date());
  const handlechange = (event) => {
    handleDateChange(event);
    onChange(event);
  };
  const updatedProps = {
    ...props,
    value: selectedDate,
  };
  return (
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <DateTimePicker onChange={handlechange} {...updatedProps} />
    </MuiPickersUtilsProvider>
  );
});
